import { render, staticRenderFns } from "./NewVersionBar.vue?vue&type=template&id=0c97305c&scoped=true"
import script from "./NewVersionBar.vue?vue&type=script&lang=js"
export * from "./NewVersionBar.vue?vue&type=script&lang=js"
import style0 from "./NewVersionBar.vue?vue&type=style&index=0&id=0c97305c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97305c",
  null
  
)

export default component.exports